<script setup lang="ts">
  import { computed } from 'vue'
  import { useCssVar } from '@vueuse/core'
  
  import { randomIntValue } from '@/utils'

  import { KsSkeleton, KsSkeletonWrapper } from '@aschehoug/kloss'

  const skeletonLoadingColor = useCssVar('--color-yellow-30')

  const generateSubjectContentSkeleton = () => ([
    { width: '2.5rem', height: '2rem' },
    { width: randomIntValue(30, 60) + '%', height: '2.5rem' },
    { width: randomIntValue(20, 40) + '%', height: '1rem' }
  ])
  
  const generateSubjectResourceSkeleton = () => ([
    { width: '100%', height: '140px' },
    { width: randomIntValue(20, 70) + '%', height: '1rem' },
    { width: randomIntValue(30, 60) + '%', height: '1.5rem' },
    { width: '100%', height: randomIntValue(1, 5) + 'rem' }
  ])

  const subjectContentSkeletons = computed(() => Array.from({ length: 8 }, () => generateSubjectContentSkeleton()))
  const subjectResourceSkeletons = computed(() => Array.from({ length: 7 }, () => generateSubjectResourceSkeleton()))
</script>

<template>
  <div class="column">
    <KsSkeleton
      :width="randomIntValue(20, 40) + '%'"
      height="4rem"
    />
    <KsSkeleton
      :width="randomIntValue(70, 90) + '%'"
      height="10rem"
      class="text"
    />
  </div>

  <div class="full-width">
    <KsSkeleton
      :width="randomIntValue(20, 40) + '%'"
      height="2.5rem"
    />
  </div>
  <div class="subject-content-box">
    <KsSkeletonWrapper
      v-for="(skeletonGroup, index) in subjectContentSkeletons"
      :key="index"
      class="sk-wrap"
    >
      <KsSkeleton
        v-for="(skeleton, idx) in skeletonGroup"
        :key="idx"
        :width="skeleton.width"
        :height="skeleton.height"
        class="text"
      />
    </KsSkeletonWrapper>
  </div>

  
  <div class="full-width">
    <KsSkeleton
      :width="randomIntValue(20, 40) + '%'"
      height="2.5rem"
    />
  </div>
  <div class="bottom">
    <KsSkeletonWrapper
      v-for="(skeletonGroup, index) in subjectResourceSkeletons"
      :key="index"
      class="sk-wrap"
    >
      <KsSkeleton
        v-for="(skeleton, idx) in skeletonGroup"
        :key="idx"
        :width="skeleton.width"
        :height="skeleton.height"
        class="text"
      />
    </KsSkeletonWrapper>
  </div>
</template>

<style scoped lang="scss">
  .column {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 96px;
  }

  .subject-content-box {
    display: flex;
    gap: 2px;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 96px;

    @include vgs-media-mobile {
      display: block;
    }

    .sk-wrap {
      width: calc(50% - 2px);
      background: var(--color-yellow-20);
      height: 104px;
      padding: 1em 3em;
      display: flex;
      flex-direction: column;
      gap: 8px;

      @include vgs-media-mobile {
        width: 100%;
        margin-top: 5px;
      }
    }

    .text {
      right: 0;
      display: block;
    }
  }

  :deep(.ks-skeleton) {
    --ks-input: v-bind(skeletonLoadingColor);
  }

  .bottom {
    display: flex;
    flex-wrap: wrap;
    gap: 24px 2px;
    margin-bottom: 96px;

    .sk-wrap {
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 28px;
      width: calc(25% - 2px);
      margin-top: 5px;
      background: var(--color-yellow-20);
      height: auto;
    }
  }

  .full-width {
    margin-bottom: 16px;
    width: 100%;
  }
</style>
